import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const dataFilterV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate DataFilter element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'dataFilter'>): void => {
    const dataFilterProps = props;

    if (dataFilterProps?.style?.container?.title && !dataFilterProps?.content?.title?.iconColor) {
      const currentColor = dataFilterProps.style.container.title.color1;
      dataFilterProps.content = {
        ...dataFilterProps.content,
        title: {
          ...dataFilterProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
